import leButton from './le-button.vue';

leButton.install = function (Vue) {
    Vue.component(leButton.name, leButton);
};

export default leButton;
